<template>
  <Icon>
    <svg slot="svg" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <polygon id="path-1-ticket-new" points="14.1666667 8.14537037 11.6041667 8.14537037 12.8851852 5.92592593 11.2819444 5 10 7.21944444 8.71851852 5 7.11527778 5.92592593 8.39722222 8.14537037 5.83333333 8.14537037 5.83333333 9.99722222 8.39675926 9.99722222 7.11527778 12.2171296 8.71851852 13.1430556 10.000463 10.9222222 11.2819444 13.1421296 12.8851852 12.2162037 11.6041667 9.99722222 14.1666667 9.99722222"></polygon>
      <g id="icons/status/new" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <rect id="Bounding-Box" x="0" y="0" width="24" height="24"></rect>
        <circle id="Oval" fill="#1DA1F2" cx="12" cy="12" r="10"></circle>
        <g id="icons/Required" transform="translate(2.000000, 3.000000)">
          <rect id="Bounding-Box" x="0" y="0" width="20" height="20"></rect>
          <mask id="mask-2-ticket-new" fill="white">
            <use xlink:href="#path-1-ticket-new"></use>
          </mask>
          <g id="Mask"></g>
          <g id="Mixin/Fill/White" mask="url(#mask-2-ticket-new)" fill="#FFFFFF" fill-rule="evenodd">
            <rect id="Box" x="0" y="0" width="20.0803213" height="20.2020202"></rect>
          </g>
        </g>
      </g>
    </svg>
  </Icon>
</template>

<script>
import Icon from "./icon";

export default {
  name: 'DsTicketNewIcon',
  components: {
    Icon
  }
};
</script>


// WEBPACK FOOTER //
// ../panel-theme/src/js/icons/ds-ticket-new-icon.vue